var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M11.5 17.5h1v1h-1v-1zm0-7.978h1V15.5h-1V9.522zm1.367-4.977a1 1 0 0 0-1.734 0l-8.01 13.957A1 1 0 0 0 3.99 20h16.02a1 1 0 0 0 .867-1.498l-8.01-13.957zm.867-.497l8.01 13.956A2 2 0 0 1 20.01 21H3.99a2 2 0 0 1-1.735-2.996l8.01-13.956a2 2 0 0 1 3.47 0z" })
  );
});